import { iDataUpdateModalProps } from '../../../model/app/Application';
import { Modals } from '../../../shared/modals/Modals';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const FunctionsUpdateModal = ({
  selectedData,
  changeHandler,
  updateData,
}: iDataUpdateModalProps) => {
  const { t } = useTranslation();
  return (
    <Modals
      modalId="modaldemo1"
      title={`${t('Functions.function')} - ID: ${selectedData?.id}`}
      body={
        <div className="form-group mb-0">
          <label htmlFor="title">{t('Functions.title')}</label>
          <input
            type="text"
            className="form-control updateModalField"
            name="title"
            key={selectedData?.title}
            defaultValue={selectedData?.title}
            onBlur={changeHandler}
            placeholder={t('Functions.enter_title')}
          />
        </div>
      }
      updateChanges={updateData!}
    />
  );
};
